"use client";

import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Lawn Maintenance",
  description: "Expert mowing and edging services to keep your Pittsburgh lawn healthy and perfectly manicured all season.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586632/img/general_landscaping_maintenance.png",
  aspect: "aspect-[3/4]"
}, {
  title: "Landscape Design",
  description: "Custom outdoor environments that blend 40 years of expertise with your home's unique architectural beauty.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586632/img/landscape_design_builds.png",
  aspect: "aspect-[3/5]"
}, {
  title: "Mulching Services",
  description: "Premium mulch installation to suppress weeds and provide a clean, professional finish to your garden beds.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586632/img/sodding_seeding_revegetation.png",
  aspect: "aspect-[3/4]"
}, {
  title: "Tree & Shrub Care",
  description: "Specialized pruning and health monitoring to protect the structural integrity and growth of your plantings.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586632/img/trees_and_shrubs_care.png",
  aspect: "aspect-[4/5]"
}, {
  title: "Spring & Fall Cleanups",
  description: "Thorough debris removal and bed preparation to transition your property beautifully through Pennsylvania seasons.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586632/img/irrigation_systems_install.png",
  aspect: "aspect-[3/4]"
}, {
  title: "Custom Patios",
  description: "Durable stone and paver surfaces designed for outdoor entertaining and long-lasting seasonal durability.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586632/img/flagstone_patios_walkways.png",
  aspect: "aspect-[3/5]"
}, {
  title: "Retaining Walls",
  description: "Engineered stone solutions that manage grade changes while adding structural elegance to your landscape.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586632/img/paver_patios_outdoor.png",
  aspect: "aspect-[3/4]"
}, {
  title: "Snow Removal",
  description: "Reliable winter plowing and salting services to ensure safety and accessibility for your Pittsburgh home.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586632/img/fire_pits_outdoor_living.png",
  aspect: "aspect-[3/4]"
}, {
  title: "Hardscape Design",
  description: "Functional stone features including walkways and stairs that integrate seamlessly with your natural terrain.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586632/img/flower_bed_planting_design.png",
  aspect: "aspect-[4/5]"
}, {
  title: "Flower Bed Care",
  description: "Curated planting and maintenance to enhance the color and visual depth of your residential gardens.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586632/img/snow_removal_winter_services.png",
  aspect: "aspect-[3/4]"
}];
export default function ServiceSpectrum() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll();
  return <section data-section-id="62284" id="our-professional-services" className="bg-background text-foreground py-24 sm:py-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {}
        <div ref={headerRef} className={cn("mb-16 max-w-2xl transition-all duration-1000 ease-out", isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="text-primary font-serif text-4xl md:text-5xl font-semibold tracking-tight mb-6">
            Our Professional Services
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl font-sans leading-relaxed">
            With over 40 years of local experience, Nieser Landscaping offers a full
            range of premium services designed to elevate and maintain your property's
            natural beauty.
          </p>
        </div>

        {}
        <div className="columns-1 md:columns-2 gap-6 space-y-6">
          {services.map((service, i) => <div key={i} data-index={i} className="break-inside-avoid">
              <Link to="/GetAnEstimatePage" className={cn("group relative block w-full overflow-hidden rounded-lg bg-card shadow-sm hover:shadow-xl transition-shadow duration-500", service.aspect)}>
                {}
                <img src={service.image} alt={service.title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110" />

                {}
                <div className="absolute inset-0 bg-primary/20 transition-colors duration-500 group-hover:bg-primary/40" />

                {}
                <div className="absolute inset-0 bg-gradient-to-t from-primary/95 via-primary/40 to-transparent opacity-80 transition-opacity duration-500 group-hover:opacity-95" />

                {}
                <div className="absolute inset-x-0 bottom-0 p-8 translate-y-12 transition-transform duration-500 ease-out group-hover:translate-y-0">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="text-white font-serif text-2xl md:text-3xl font-semibold">
                      {service.title}
                    </h3>
                    <span className="text-accent opacity-0 -translate-x-4 transition-all duration-500 group-hover:opacity-100 group-hover:translate-x-0">
                      <ArrowUpRight className="h-7 w-7" />
                    </span>
                  </div>
                  
                  <div className="overflow-hidden">
                    <p className="text-white/90 font-sans text-base leading-relaxed opacity-0 transition-opacity duration-500 delay-100 group-hover:opacity-100">
                      {service.description}
                    </p>
                  </div>
                </div>
              </Link>
            </div>)}
        </div>
      </div>
    </section>;
}